const ipAddr = "api.loubansolutions.com";

const config = {
  apiUrl: `https://${ipAddr}/backend_commerciale/`,
  // Remove HTTP fallback to ensure HTTPS is always used
};

export default config;